import { AreaType } from "@sparkware/uc-sdk-core";
import { CHANNEL_SOURCE, CHANNEL_ELEMENTS } from "../../../../../common/const/casinofied-analytics-consts";
import { DeepLinkActionBase } from "../deep-link-action-base";
import {ISendElasticEventOptions} from "../../../analytics/analytics.service.interface";

export class FreeToPlayDeeplinkAction extends DeepLinkActionBase {
  async execute() {
    // user must be logged in to be F2P eligible!
    if(!this.services.user.isAuthorized){
      await this.services.user.openLogin(this.descriptor.marketingParams);
    }

    await this.services.freeToPlay.waitForEligibility();
    if (!this.services.freeToPlay.isPromotionEligible) {
      return Promise.reject('Free to play is not enabled or user is not eligible!');
    }

    const id = this.descriptor.actionParams.id;

    /*
    deeplink={"action":"free-to-play","id":"unspecified/1/2"}
    no id or 0 - miniArena
    1 = dailywhish game
    2 = deposit wheel
    */

    let gameStage = "";
    switch (id) {
      case "1":
        gameStage = "dailyWish";
        break;

      case "2":
        gameStage = "depositWheel";
        break;

      case "0":
      default:
        gameStage = "miniArena";
        break;
    }

    const specificParams = {gameStage: gameStage};

    this._sendAnalytics(gameStage);

    await this.services.freeToPlay.showPromotion({
      channel: {
          area: AreaType.externalClick,
          source: CHANNEL_SOURCE.casinoClient,
          element: CHANNEL_ELEMENTS.deepLink
      },
      appSpecificParameters: specificParams
    });
  }

  private _sendAnalytics(gameStage:string) {
    try {
      let options: ISendElasticEventOptions = {
        action: "CLICK",
        category: "Deep_link",
        eventType: "bonus_widget",
        value: gameStage,
        appID: "F2P",
        customData: {
          location: this.services.location.isHomePage ? 'homepage' : this.services.location.currentUri.pathName.toString(),
          segmentation: this.services.user.playerRMSStatus
        }
      };
      this.services.analytics.sendElasticInfoEvent(options, true);
    }
    catch (err){
      console.log("F2P Deep_link analytics report failed with error: "+ err);
    }
  }
}